import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

import { AccountsItem } from '../type';

export interface SecuritiesRequest {
  companyId: string;
  startDate: string;
  endDate: string;
}

interface SecuritiesOverview {
  displayAccounts: AccountsItem[];
  hiddenAccounts: AccountsItem[];
}

export const getSecurities = ({ companyId, startDate, endDate }: SecuritiesRequest) => {
  return API.get<ResponseBaseWithData<SecuritiesOverview>>(
    `/api/v3/companies/${companyId}/cashflow-overview/securities`,
    {
      params: {
        startDate,
        endDate,
      },
    },
  );
};
